import React, { useEffect, useState } from "react"
import { Row, Col } from "reactstrap"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"

import { getAllClients, getAllClientsByCategory } from "../../../helpers/API"
import { adminRoot } from "../../../constants/defaultValues/defaultValues"
import TableControler from "components/ModuleElements/Table/TableControler"
import { queryDataByParameters } from "helpers/Utils"

const StartPage = ({ title, getClients, history, t }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setTimeout(async () => {
      const data = await getClients()
      setData(data)
      setLoading(false)
    }, 100)
  }, [getClients])

  const openClient = clientID => {
    history.push(`${adminRoot}home?clientID=${clientID}`)
    history.go()
  }

  const queryData = async params => {
    const _params = { ...params }
    if (params.searchKeyword) {
      _params.searchBy = { key: "Name", value: params.searchKeyword }
    }
    return queryDataByParameters(data, _params)
  }

  return (
    <>
      <div className="page-content">
        <div className="container-fluid p-1">
          <Row>
            <Col>
              <div className="d-flex flex-column min-width-zero margin-bottom-10">
                <h1>{t(title)}</h1>
              </div>

              {loading ? (
                <div className="loading" />
              ) : (
                <TableControler
                  getData={async params => {
                    return queryData(params)
                  }}
                  columns={[{ key: "Name", label: "Name" }]}
                  openButton={{
                    show: true,
                    onClick: ID => openClient(ID),
                    index: 0,
                  }}
                />
              )}
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = () => {
  return {}
}
const mapActionToProps = {}

export default withTranslation()(
  connect(mapStateToProps, mapActionToProps)(StartPage)
)
